/* Shopify corrido printing: existing quote format, optional Proyecta views. */
(() => {
  if (window.altaCorridoPrintInstalled) return;
  const button = document.querySelector('.plafon-corrido-tablaroca-page .alta-presupuesto-print-button');
  const form = document.forms.namedItem('plafon');
  if (!button || !form || typeof window.formatPrintedElement !== 'function' ||
      typeof window.buildSharedBudgetPrintStyles !== 'function') return;
  window.altaCorridoPrintInstalled = true;
  const origin = 'https://proyecta.altamateriales.com.mx';
  const controls = document.createElement('div');
  controls.className = 'alta-corrido-print-controls';
  const label = document.createElement('label');
  const checkbox = document.createElement('input');
  checkbox.type = 'checkbox';
  checkbox.checked = true;
  checkbox.id = 'alta-corrido-include-views';
  label.append(checkbox, ' Incluir las seis vistas del sistema en la impresión');
  const status = document.createElement('div');
  status.className = 'alta-corrido-print-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  const spinner = document.createElement('span');
  spinner.className = 'alta-corrido-print-spinner';
  spinner.setAttribute('aria-hidden', 'true');
  const message = document.createElement('span');
  status.append(spinner, message);
  status.hidden = true;
  controls.append(label, status);
  form.prepend(controls);
  const uiStyle = document.createElement('style');
  uiStyle.textContent = `
    .alta-corrido-print-controls{padding:12px 0;font-size:14px}
    .alta-corrido-print-controls label{display:flex;align-items:center;gap:8px;cursor:pointer}
    .alta-corrido-print-controls input{width:18px;height:18px;accent-color:#12385f;flex-shrink:0}
    .alta-corrido-print-status{display:flex;align-items:center;gap:10px;margin-top:10px;color:#12385f}
    .alta-corrido-print-status[hidden]{display:none}
    .alta-corrido-print-spinner{width:22px;height:22px;border:3px solid #d8e1ee;border-top-color:#12385f;border-radius:50%;animation:alta-corrido-spin .8s linear infinite;flex-shrink:0}
    .alta-corrido-print-spinner[hidden]{display:none}
    @keyframes alta-corrido-spin{to{transform:rotate(360deg)}}
    @media(prefers-reduced-motion:reduce){.alta-corrido-print-spinner{animation-duration:2s}}
    @media print{.alta-corrido-print-controls{display:none}}
  `;
  document.head.append(uiStyle);
  let printFrame = null;
  let cachedViews = null;
  let busy = false;
  function makeFrame(title) {
    const frame = document.createElement('iframe');
    frame.title = title;
    frame.tabIndex = -1;
    frame.setAttribute('aria-hidden', 'true');
    frame.style.cssText = 'position:fixed;left:-10000px;top:0;width:1200px;height:900px;border:0;pointer-events:none';
    return frame;
  }
  async function getViews(length, width) {
    const key = `${length}x${width}`;
    if (cachedViews?.key === key) return cachedViews.images;
    const frame = makeFrame('Generador de vistas del plafón');
    // Offscreen cross-origin frames may have animation callbacks paused.
    frame.style.cssText = 'position:fixed;left:0;top:0;width:100vw;height:100vh;border:0;opacity:0.01;pointer-events:none;z-index:-1';
    const requestId = crypto.randomUUID();
    try {
      const images = await new Promise((resolve, reject) => {
        const cleanup = () => {
          clearInterval(retry);
          clearTimeout(timeout);
          window.removeEventListener('message', receive);
        };
        const receive = event => {
          if (event.origin !== origin || event.source !== frame.contentWindow ||
              event.data?.requestId !== requestId) return;
          if (event.data.type === 'alta:quote-views:error') {
            cleanup(); reject(new Error('No se pudieron generar las vistas.')); return;
          }
          if (event.data.type !== 'alta:quote-views:result') return;
          const images = event.data.images;
          if (!Array.isArray(images) || images.length !== 6 ||
              !images.every(image => typeof image.name === 'string' &&
                typeof image.url === 'string' && image.url.startsWith('data:image/png;base64,'))) return;
          cleanup(); resolve(images);
        };
        const retry = setInterval(() => frame.contentWindow?.postMessage({
          type: 'alta:quote-views:request', requestId,
        }, origin), 1000);
        const timeout = setTimeout(() => {
          cleanup(); reject(new Error('No se pudieron preparar las vistas a tiempo. Puedes desmarcarlas para imprimir solo el presupuesto.'));
        }, 60000);
        window.addEventListener('message', receive);
        frame.src = `${origin}/sistema-corrido?quotePrint=1&length=${length}&width=${width}`;
        document.body.append(frame);
      });
      cachedViews = { key, images };
      return images;
    } finally { frame.remove(); }
  }
  button.removeAttribute('onclick');
  button.addEventListener('click', async () => {
    if (busy) return;
    const length = Number(form.elements.namedItem('txtLargo').value);
    const width = Number(form.elements.namedItem('txtAncho').value);
    const includeViews = checkbox.checked;
    status.hidden = false;
    spinner.hidden = false;
    if (includeViews && ![length, width].every(n => Number.isFinite(n) && n >= 0.5 && n <= 20)) {
      spinner.hidden = true;
      message.textContent = 'Para incluir las seis vistas, ingresa largo y ancho entre 0.50 y 20 m.';
      return;
    }
    busy = true;
    button.disabled = true;
    checkbox.disabled = true;
    button.setAttribute('aria-busy', 'true');
    message.textContent = includeViews ? 'Preparando presupuesto y seis vistas…' : 'Preparando presupuesto…';
    let nextFrame = null;
    try {
      const quote = window.formatPrintedElement('plafon',
        'Presupuesto Para Plafon Corrido Sistema Tablaroca');
      quote.querySelectorAll('.alta-corrido-print-controls').forEach(node => node.remove());
      const images = includeViews ? await getViews(length, width) : [];
      printFrame?.remove();
      nextFrame = makeFrame('Presupuesto para impresión');
      document.body.append(nextFrame);
      const printWindow = nextFrame.contentWindow;
      const doc = printWindow.document;
      doc.title = 'Presupuesto para plafón corrido';
      const style = doc.createElement('style');
      style.textContent = window.buildSharedBudgetPrintStyles() + `
        .print-budget-shell{position:relative;isolation:isolate}
        .print-budget-shell > .alta-quote-watermark-grid{position:absolute;z-index:5}
        .print-budget-shell .alta-quote-total th,.print-budget-shell .alta-quote-total td{background:#ffffff!important;color:#17324d!important}
        .print-budget-shell .alta-quote-total input[name="txtTOT"]{background:#ffffff!important;font-weight:800!important;color:#12385f!important;-webkit-text-fill-color:#12385f!important;opacity:1!important;border-color:#d6e0ea!important;-webkit-print-color-adjust:exact;print-color-adjust:exact}
        .alta-quote-watermark-grid{position:absolute;inset:80px 0 0;display:grid;grid-template-columns:repeat(3,1fr);grid-template-rows:repeat(4,1fr);align-items:center;justify-items:center;pointer-events:none;z-index:5;opacity:0.04;-webkit-print-color-adjust:exact;print-color-adjust:exact}
        .alta-quote-watermark-grid img{width:75%;max-width:140px;height:auto}
        .alta-quote-views{position:relative;isolation:isolate;break-before:page;padding:16px 18px 22px;max-width:960px;margin:0 auto}
        .alta-quote-views h2{font-size:20px;color:#12385f}
        .alta-quote-views p{font-size:11px;color:#4a6079}
        .alta-quote-view-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .alta-quote-view-grid figure{margin:0;break-inside:avoid}
        .alta-quote-view-grid img{width:100%;display:block}
        .alta-quote-view-grid figcaption{text-align:center;font-size:11px}
      `;
      const bootstrap = doc.createElement('link');
      bootstrap.rel = 'stylesheet';
      bootstrap.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
      const stylesReady = new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('No se pudo cargar el formato de impresión.')), 15000);
        bootstrap.onload = () => { clearTimeout(timeout); resolve(); };
        bootstrap.onerror = () => { clearTimeout(timeout); reject(new Error('No se pudo cargar el formato de impresión.')); };
      });
      doc.head.append(bootstrap, style);
      const watermarks = doc.createElement('div');
      watermarks.className = 'alta-quote-watermark-grid';
      watermarks.setAttribute('aria-hidden', 'true');
      const watermarkUrl = quote.querySelector('.print-budget-watermark')?.src;
      if (watermarkUrl) {
        for (let index = 0; index < 12; index++) {
          const logo = doc.createElement('img');
          logo.src = watermarkUrl;
          logo.alt = '';
          watermarks.append(logo);
        }
      }
      quote.querySelector('.print-budget-watermark')?.remove();
      quote.append(watermarks.cloneNode(true));
      const total = quote.querySelector('input[name="txtTOT"]');
      total?.style.setProperty('font-weight', '800', 'important');
      total?.style.setProperty('color', '#12385f', 'important');
      total?.style.setProperty('-webkit-text-fill-color', '#12385f', 'important');
      total?.closest('tr')?.classList.add('alta-quote-total');
      doc.body.append(quote);
      if (includeViews) {
        doc.body.classList.add('alta-quote-with-views');
        const section = doc.createElement('section');
        section.className = 'alta-quote-views';
        const heading = doc.createElement('h2');
        heading.textContent = `Sistema corrido · ${length.toFixed(2)} × ${width.toFixed(2)} m`;
        const note = doc.createElement('p');
        note.textContent = 'Seis vistas ilustrativas, sin escala. Caída de referencia: 0.50 m. Validar condiciones de instalación. Cantidades y precios según el presupuesto.';
        const grid = doc.createElement('div');
        grid.className = 'alta-quote-view-grid';
        images.forEach(image => {
          const figure = doc.createElement('figure');
          const img = doc.createElement('img');
          img.src = image.url;
          img.alt = `Vista ${image.name}`;
          const caption = doc.createElement('figcaption');
          caption.textContent = image.name;
          figure.append(img, caption);
          grid.append(figure);
        });
        section.append(heading, note, grid, watermarks);
        doc.body.append(section);
      }
      let readyTimeout;
      try {
        await Promise.race([
          Promise.all([stylesReady, ...[...doc.images].map(img => img.decode())]),
          new Promise((_, reject) => {
            readyTimeout = setTimeout(() => reject(new Error('No se pudieron cargar las imágenes de impresión.')), 20000);
          }),
        ]);
      } finally { clearTimeout(readyTimeout); }
      status.hidden = true;
      printFrame = nextFrame;
      // Retain the document until the next print attempt: some browsers return
      // from print() before the native dialog closes.
      printWindow.focus();
      printWindow.print();
    } catch (error) {
      nextFrame?.remove();
      spinner.hidden = true;
      status.hidden = false;
      message.textContent = `${error.message} Vuelve a intentar.`;
    } finally {
      busy = false;
      button.disabled = false;
      checkbox.disabled = false;
      button.removeAttribute('aria-busy');
      button.focus({ preventScroll: true });
    }
  });
})();
